"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDocumentStatus = void 0;
const class_validator_1 = require("class-validator");
const Customer_1 = __importDefault(require("./Customer"));
const DocumentHistory_1 = __importDefault(require("./DocumentHistory"));
const DocumentType_1 = __importDefault(require("./DocumentType"));
const File_1 = __importDefault(require("./File"));
const OfficeFolder_1 = __importDefault(require("./OfficeFolder"));
const Resource_1 = __importDefault(require("../Resource"));
const classTransformer_1 = require("../classTransformer");
class Document extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.created_at = null;
        this.updated_at = null;
    }
}
exports.default = Document;
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createFile"], message: "UID is required" }),
    __metadata("design:type", String)
], Document.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], Document.prototype, "document_status", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => DocumentType_1.default),
    __metadata("design:type", DocumentType_1.default)
], Document.prototype, "document_type", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => OfficeFolder_1.default),
    __metadata("design:type", OfficeFolder_1.default)
], Document.prototype, "folder", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Customer_1.default),
    __metadata("design:type", Customer_1.default)
], Document.prototype, "depositor", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], Document.prototype, "depositor_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], Document.prototype, "folder_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], Document.prototype, "third_party_depositor_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], Document.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], Document.prototype, "updated_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], Document.prototype, "deleted_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], Document.prototype, "deleted_by_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => File_1.default),
    __metadata("design:type", Array)
], Document.prototype, "files", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => DocumentHistory_1.default),
    __metadata("design:type", Array)
], Document.prototype, "document_history", void 0);
var EDocumentStatus;
(function (EDocumentStatus) {
    EDocumentStatus["ASKED"] = "ASKED";
    EDocumentStatus["DEPOSITED"] = "DEPOSITED";
    EDocumentStatus["VALIDATED"] = "VALIDATED";
    EDocumentStatus["REFUSED"] = "REFUSED";
    EDocumentStatus["SENT"] = "SENT";
    EDocumentStatus["DOWNLOADED"] = "DOWNLOADED";
})(EDocumentStatus || (exports.EDocumentStatus = EDocumentStatus = {}));
